<template>
  <div>
    <div>{{ text }}</div>
    <div>{{ active }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    active: Boolean
  }
};
</script>

<style></style>
